// extracted by mini-css-extract-plugin
module.exports = {"newsByTagContainer":"NewsByTag_newsByTagContainer__1Fysi","heading":"NewsByTag_heading__kimgO","pagination":"NewsByTag_pagination__1kYPX","grid":"NewsByTag_grid__3_qPL"};